import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const designationsuffixAdapter = createEntityAdapter({})

const initialState = designationsuffixAdapter.getInitialState()

export const designationsuffixApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getdesignationsuffix: builder.query({
            query: () => ({
                url: '/designationsuffix',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadeddesignationsuffix = responseData.map(designationsuffix => {
                    // console.log(designationsuffix)
                    designationsuffix.id = designationsuffix._id
                    // console.log(designationsuffix)
                    return designationsuffix
                });
                return designationsuffixAdapter.setAll(initialState, loadeddesignationsuffix)
            },
            providesTags: (result, error, arg) => {
                console.log(result.ids) 
                if (result?.ids) {
                    return [
                        { type: 'DESIGNATIONSUFFIX', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'DESIGNATIONSUFFIX', id }))
                    ]
                } else return [{ type: 'DESIGNATIONSUFFIX', id: 'LIST' }]
            }
        }),
        addNewdesignationsuffix: builder.mutation({
            query: initialUserData => ({
                url: '/designationsuffix',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'DESIGNATIONSUFFIX', id: "LIST" }
            ]
        }),
        updatedesignationsuffix: builder.mutation({
            query: initialUserData => ({
                url: '/designationsuffix',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'DESIGNATIONSUFFIX', id: arg.id }
            ]
        }),        
        deletedesignationsuffix: builder.mutation({
            query: ({ id }) => ({
                url: `/designationsuffix`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'DESIGNATIONSUFFIX', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetdesignationsuffixQuery,
    useAddNewdesignationsuffixMutation,
    useUpdatedesignationsuffixMutation,
    useDeletedesignationsuffixMutation, 
} = designationsuffixApiSlice

// returns the query result object
export const selectdesignationsuffixResult = designationsuffixApiSlice.endpoints.getdesignationsuffix.select()

// creates memoized selector
const selectdesignationsuffixData = createSelector(
    selectdesignationsuffixResult,
    designationsuffixResult => designationsuffixResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAlldesignationsuffix,
    selectById: selectdesignationsuffixById,
    selectIds: selectdesignationsuffixIds
    // Pass in a selector that returns the users slice of state
} = designationsuffixAdapter.getSelectors(state => selectdesignationsuffixData(state) ?? initialState)